import api from "./api";

const feeService = {
    getMarketplaceBuyFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getMarketplaceBuyFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getExchangeBuyFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getExchangeBuyFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getExchangeSellFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getExchangeSellFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getDepositFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getDepositFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getWithdrawFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getWithdrawFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
    getTransferOutFeeByActiveId: (jwttoken, activeId) =>
        api.get(`/fee-data/getTransferOutFeeByActiveId/${activeId}`, { 
            headers: { 'Authorization': `Basic ${jwttoken}` } 
        }),
        
};

export default feeService;